import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Title = styled.span`
  display: inline-block;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const Subtitle = styled(Title)`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;

  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 15px;
    margin-top: 4px;
  }
`;

export const ControlsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

export const ButtonSelectAll = styled.button`
  background: transparent;
  border: 1px solid #0b29fb;
  border-radius: 5px;
  height: 47px;
  font-family: 'Mangueira';
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #0b29fb;
  padding: 0 20px;

  @media (max-width: 768px) {
    width: 118px;
    height: 34px;
    font-size: 12px;
    text-align: center;
    padding: 0 2px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 47px;
  padding: 0 12px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;

  @media (max-width: 768px) {
    height: 34px;
    width: 186px;
    padding: 0 4px;
  }
`;

export const InputSearch = styled.input`
  all: unset;
  color: #3d3d3d;
  font-family: 'Mangueira';
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;

  &::placeholder {
    color: #d9d9d9;
  }
`;
